import PropTypes from 'prop-types';

import emptyIllustration from 'assets/invite-already-accepted.png';

import styles from 'Pages/TeamDashboard/ProductLibrary/styles.module.scss';

const EmptyState = ({ onAddFlow }) => (
  <div className={styles.emptyState}>
    <img
      src={emptyIllustration}
      alt="Empty product library"
      className={styles.illustration}
    />

    <div className={styles.copy}>
      <p className={styles.emptyTitle}>
        Your product library is empty
      </p>
      <p className={styles.emptySubtitle}>
        {onAddFlow
          ? 'Start by adding your first user flow, such as sign up or onboarding'
          : 'No flows have been added yet'}
      </p>
    </div>

    {onAddFlow && (
      <button className={styles.buttonPrimary} onClick={onAddFlow}>
        Add flow manually
      </button>
    )}
  </div>
);

EmptyState.propTypes = {
  onAddFlow: PropTypes.func,
};

EmptyState.defaultProps = {
  onAddFlow: null,
};

export default EmptyState;
